import { all, fork, put, takeLatest } from 'redux-saga/effects';

import {
    CHANGE_ROUTER,
    LEAVING_ROUTER
} from '../../../iwRouter/IwRouter.actions';

export function createWorkersForPage(options) {
    let pageFlowTasks = [];

    return [fork(pageRouterWorker), fork(pageLeaveProcessWorker)];

    function* pageRouterWorker() {
        yield takeLatest(CHANGE_ROUTER, function* (action) {
            if (options.isInPageLocation(action.location)) {
                const workers = options.createPageFlowWorkers();
                pageFlowTasks = yield all(workers);

                if (!action.disableFirstRouterChange) {
                    yield put({ type: `page/${options.page} [activate]` });
                }
            }
        });
    }

    function* pageLeaveProcessWorker() {
        yield takeLatest(LEAVING_ROUTER, function* (action) {
            if (isLeavingPage(action)) {
                yield put({ type: `page/${options.page} [leaving]` });
                for (let saga of pageFlowTasks) {
                    saga.cancel();
                }
            }
        });
    }

    function isLeavingPage(action) {
        return (
            options.isInPageLocation(action.from) &&
            !options.isInPageLocation(action.to)
        );
    }
}
